import { useAuth } from '../auth/AuthContext';

export interface PermissionCheckResult {
  canView: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canVoid: boolean;
  canExport: boolean;
}

/**
 * Hook to check user permissions for a specific module
 * @param moduleName - The module name to check permissions for
 * @returns PermissionCheckResult with boolean flags for each permission
 */
export const useModulePermission = (moduleName: string): PermissionCheckResult => {
  const { user } = useAuth();

  // Default all to false if no user or permissions
  const defaultResult: PermissionCheckResult = {
    canView: false,
    canAdd: false,
    canEdit: false,
    canVoid: false,
    canExport: false,
  };

  if (!user?.userPermissionList || user.userPermissionList.length === 0) {
    return defaultResult;
  }

  // Find permission for this module (case-insensitive)
  const permission = user.userPermissionList.find(
    (p) => p.moduleName?.toLowerCase() === moduleName.toLowerCase()
  );

  if (!permission) {
    return defaultResult;
  }

  return {
    canView: permission.isView === true,
    canAdd: permission.isAdd === true,
    canEdit: permission.isEdit === true,
    canVoid: permission.isVoid === true,
    canExport: permission.isExport === true,
  };
};
